// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3fFUQ","title":"BackImages_title__ESU3f","images":"BackImages_images__2hZrX"};